var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38179 1.59998L1.50244 2.46498L12.8182 13.6L13.6975 12.7347L2.38179 1.59998Z",
    fill: "#182B1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36031 4.29298L4.18798 5.10742C3.28194 5.86653 2.56046 6.81145 2.09423 7.63818L2.09281 7.64097C3.39126 9.77722 5.4515 11.7961 8.05179 11.4899C8.75368 11.4072 9.40844 11.1711 10.0067 10.8333L10.8446 11.6575C9.67847 12.394 8.34169 12.7841 6.89333 12.5913C4.28168 12.2437 2.14619 10.136 0.800049 7.66053C1.43209 6.40912 2.29668 5.21191 3.36031 4.29298ZM5.24281 3.086C5.97309 2.76581 6.76329 2.5775 7.60715 2.56409C7.654 2.56381 8.21023 2.58979 8.46236 2.63059C8.62052 2.65629 8.7781 2.68842 8.93342 2.72837C11.4108 3.36344 13.2461 5.42425 14.4 7.54737C13.9159 8.50933 13.2819 9.44809 12.5258 10.2525L11.7231 9.46262C12.2816 8.87031 12.7473 8.21093 13.1059 7.5714C13.1059 7.5714 12.7453 7.00088 12.4718 6.64269C12.2961 6.41247 12.1112 6.18896 11.917 5.97354C11.7637 5.80367 11.1683 5.22672 11.0266 5.10658C10.076 4.3022 8.95982 3.67105 7.62106 3.68167C7.10259 3.68977 6.604 3.79035 6.13068 3.95967L5.24281 3.086Z",
    fill: "#182B1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61335 6.51037L6.25229 7.13883L8.71166 9.55885C8.38286 9.74045 8.00352 9.84383 7.60005 9.84383C6.34363 9.84383 5.32373 8.84024 5.32373 7.60392C5.32373 7.2069 5.42907 6.83391 5.61335 6.51037ZM7.55803 5.36457C7.57194 5.36429 7.58614 5.36401 7.60005 5.36401C8.85647 5.36401 9.87637 6.36788 9.87637 7.60392C9.87637 7.61789 9.87637 7.63158 9.87609 7.64527L7.55803 5.36457Z",
    fill: "#182B1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.3d55e16f.svg";
export { ForwardRef as ReactComponent };